import React, { ComponentType } from 'react';

export function withRequiredProp<TProps, TKey extends keyof TProps>(
    Component: ComponentType<TProps & Pick<Required<TProps>, TKey>>,
    Fallback: ComponentType<TProps>,
    property: TKey,
) {
    return (props: TProps & Pick<Partial<TProps>, TKey>) => {
        if (typeof props[property] === 'undefined') {
            return <Fallback {...props} />;
        }

        // @ts-ignore
        return <Component {...props} />;
    };
}
